import { render } from "./InviteTeammatePage.vue?vue&type=template&id=edd561ce&scoped=true"
import script from "./InviteTeammatePage.vue?vue&type=script&lang=js"
export * from "./InviteTeammatePage.vue?vue&type=script&lang=js"

import "./InviteTeammatePage.vue?vue&type=style&index=0&id=edd561ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edd561ce"]])

export default __exports__